import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { adminMenu, workerMenu } from "./constants";

import { Box } from "@/components/atoms";
import { Main } from "#/templates";
import { useApi } from "@/api";

const RequireWorker = ({ children }: { children: JSX.Element }) => {
  const { session } = useApi();
  const location = useLocation();
  const navigate = useNavigate();

  if (!session.isLoggedIn() || !session.user ||
        (!session.user?.admin && !session.user?.worker && !session.isInRole('worker'))) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  const handleEditProfile = () => {
    navigate('/account-worker')
  }

  return (
    <Main
      user={{
        firstName: session.user.firstName,
        lastName: session.user.lastName,
      }}
      navigation={{ menus: session?.user?.admin ? adminMenu : workerMenu, onLogout:session.logout }}
      onEditProfile={handleEditProfile}
    >
      <Box margin="50px 0 0px">
        {children}
      </Box>
    </Main>
  );
}

export default RequireWorker;
